//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiCell from "../../components/cell/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { bulkCreateMember } from "../../services/users";
import { showErrorMsg } from "../../utils/error";

export default {
  name: "AssignInstagramPage",
  components: { HiHeader, HiButton, InstagramUserItem, HiCell },
  data() {
    return {
      selectIds: [],
    };
  },
  methods: {
    /**
     * 单条记录点击事件
     */
    async itemClick(item) {
      if (item.type === "unselect") {
        await this.$alert.show({
          cancelText: "", // 不知道什么鬼。。总是被自动设置成cancel。。
          text: "You can only add unlimited schedules account.",
          yesText: "Ok",
        });
        return;
      }
      // 查看以选中项中是否包含点击项
      const index = this.selectIds.findIndex((id) => {
        return item.publisherId === id;
      });
      // 如果不存在，则添加当前点击项到数组中
      if (index === -1) {
        this.selectIds.push(item.publisherId);
      } else {
        // 否则删除该项
        this.selectIds.splice(index, 1);
      }
    },
    /**
     * invite按钮点击事件
     */
    async inviteClick() {
      if (this.user.memberRemaining === 0) {
        // 并彈出升級提示
        await this.$confirm.show({
          text: this.$t("myPlanPage.teamMember.upgradeText"),
          yesText: this.$t("common.upgrade"),
        });
        this.$router.push({
          name: "PaymentUpgradePage",
          params: { type: "filter" },
        });
        return;
      }
      try {
        this.$loading.show();
        await bulkCreateMember({
          email: this.$route.params.email,
          ids: this.selectIds,
        });
        this.$router.go(-2);
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member)
      let types = [];
      this.user.linkedInstagramList.forEach((l) => {
        l.select =
          this.selectIds.find((id) => id === l.publisherId) !== undefined;
      });
      const limitedPublishers = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember && l.status !== 2
      );
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && !l.isMember && l.status !== 2
      );
      if (unlimitedPublishers.length > 0) {
        types.push({
          title: this.$t("addUnlimitedAccountPage.normalUnlimitedUserType"),
          items: unlimitedPublishers.map((p) => {
            return { ...p, type: "select" };
          }),
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          title: this.$t("addUnlimitedAccountPage.freeUserType"),
          items: limitedPublishers.map((p) => {
            return { ...p, type: "unselect" };
          }),
        });
      }
      return types;
    },
  },
  activated() {
    this.selectIds = [];
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/AssignInstagram.vue